import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloTestRetest } from '@api/sdk.gen';
import { KubesoloHostResult, KubesoloTest } from '@api/types.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

export function useRetestMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      testId,
      hostIds,
    }: {
      testId: KubesoloTest['id'];
      hostIds: Array<KubesoloHostResult['id']>;
    }) =>
      kubesoloTestRetest({ path: { id: testId }, body: { hostIDs: hostIds } }),
    ...withInvalidate(queryClient, [queryKeys.active()]),
    ...withError('Unable to re-test the machines'),
  });
}
